const referenceComps = [
  {
    multiple: "Financial Services",
    count: "15",
    ev: "7.5x",
    revenue: "2.5x"
  }
]

export const repeatedReferenceComps = Array.from(
  { length: 3 },
  () => referenceComps[0]
)
